import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://api-np-st1.complydome.io/config/application-constants/np-st1',
  stripePubKey: 'pk_test_51R1XzFRw67O6xpVUSWusDaqxYaAO9lB5FippWBb3CIiokqN0SpLdbbTuDOmT5Yy9dCX9w46XFoHYusB8kzQAJwyu00136VOEFB',
  syncfusionKey: 'NxYtGyMROh0gHDMgDk1jXk9FaF5LVmdWf0x0RWFfb196cVdMZV1BJAtUQF1hT35QdkdiWnpdc3FQQWlaWkd0',
  tidioScriptUrl: '//code.tidio.co/umghtd43atmsogxzl4shkbs1lphhujma.js',
  socketUrl: 'wss://routing-np-st1.complydome.io/messaging-service/ws/user',
  baseSocketUrl: 'wss://routing-np-st1.complydome.io/messaging-service',
};
